import React, { useMemo } from 'react'

const Input = ({
    label,
    name,
    onChange,
    error,
    register = null,
    placeholder = "",
    htmlFor = "",
    id = "",
    className = "",
    keyName = ""
}) => {
    const handleChange = (e) => {
        onChange(e.target.value);
    }

    const inputClass = useMemo(() => {
        return className ? className : 'bg-transparent text-white border border-gray-500 rounded-[6px] p-[10px] lg:p-[20px] w-full placeholder:text-[#4D4D4D] h-[40px] lg:h-[50px] placeholder:text-[0.8rem] focus:outline-none'
    }, [className])

    return (
        <div>
            {
                label && (
                    <label className='block text-[14px] text-primary-color mb-[10px]' htmlFor={htmlFor}> {label} </label>
                )
            }
            <input 
                id={id}
                key={keyName}
                onChange={handleChange} 
                name={name}
                className={inputClass} 
                type="text" 
                placeholder={placeholder} 
                {...(register ? register(name) : {})}
            />
            <p className='error text-red-500 text-[12px] mt-[10px]'>{error}</p>
        </div>
    )
}

export default Input